module.exports = __webpack_public_path__ + "img/icon-home.dark.1d960df9.svg";